'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.core.pipeline.config.preconditions.types.clusterSize', [])
  .config(function(preconditionTypeConfigProvider) {
    preconditionTypeConfigProvider.registerPreconditionType({
      label: 'Cluster Size',
      key: 'clusterSize',
      contextTemplateUrl: require('./additionalFields.html'),
    });
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/pipeline/config/preconditions/types/clusterSize/clusterSize.precondition.type.module.js